import React, { useState } from "react";
import styled from "styled-components";
import Buttons from "../../../../components/Button/button.component";
import { colors } from "../../../../theme/color";

const DisableUserModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  backdrop-filter: blur(2px);
`;

const DisableUserModalCon = styled.div`
  width: 30%;
  overflow-y: scroll;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0px 8px 8px -4px #10182808;
  box-shadow: 0px 20px 24px -4px #10182814;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    max-height: 90vh;
  }
`;

const DisableUserDetails = styled.div``;

const DisableUserMainText = styled.h2`
  font-weight: 700;
  font-size: 18px;
  line-height: 32px;
  width: 30%;
  margin: 0 auto;
  padding: 0;
`;

const DisableUserText = styled.h5`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #8c8b8b;
  width: 70%;
  margin: 0 auto;
  padding: 0;
`;

export const DisableModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 70px;
  margin-top: 30px;

  @media screen and (max-width: 768px) {
    margin-top: 15px;
    margin-left: 2px;
  }
`;

export const DisableButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 40%;
`;

export const DisableButtonContainer1 = styled.div`
  display: flex;
  justify-content: center;
  width: 40%;
  margin-right: 30px;
`;

interface DisableUsersModalProps {
  onClose: () => void;
  onSubmit: () => void;
}

const DisableUsersModal: React.FC<DisableUsersModalProps> = ({ onClose }) => {
  const [modalOpen, setModalOpen] = useState(true);

  const handleCancel = () => {
    setModalOpen(false);
  };

  return modalOpen ? (
    <DisableUserModalWrapper>
      <DisableUserModalCon>
        <div style={{ padding: "30px 10px 10px 10px" }}>
          <DisableUserDetails>
            <DisableUserMainText>Disable Users</DisableUserMainText>
            <DisableUserText>
              Are you sure you want to disable all the users?
            </DisableUserText>
          </DisableUserDetails>

          <DisableModalButtonContainer>
            <DisableButtonContainer1>
              <Buttons
                label="Yes, Cancel"
                cursor="pointer"
                border="10px"
                width="100%"
                height="44px"
                borderLine="1px solid #AFAFAF"
                color={colors.White}
                textColor={colors.NEUTRAL_GREY}
                handleClick={handleCancel}
                style={{
                  width: "70%",
                  height: "34px",
                  borderRadius: "10px",
                  border: "1px solid #AFAFAF",
                  color: "#AFAFAF",
                  backgroundColor: "white",
                }}
              />
            </DisableButtonContainer1>
            <DisableButtonContainer>
              <Buttons
                label="Yes, Disable"
                cursor="pointer"
                border="10px"
                width="100%"
                height="44px"
                color={colors.ButtonBackgroundColors.primaryDefaultButton}
                // disabled={!isFormValid()}
                style={{
                  width: "100%",
                  height: "34px",
                  borderRadius: "10px",
                  color: "white",
                  backgroundColor: "#00A603",
                }}
              />
            </DisableButtonContainer>
          </DisableModalButtonContainer>
        </div>
      </DisableUserModalCon>
    </DisableUserModalWrapper>
  ) : null;
};

export default DisableUsersModal;
